'use strict';

$(function() {
	function setup() {
        Fancybox.bind("[data-fancybox]", {
            contentClick: "toggleZoom",
            'on': {
                'close': (event, slide) => {
                    $('#fancybox-content-description-text').remove();
                    $('.fancybox-content-description').removeClass()
                },
            },
            Images: {
                content: (_ref, slide) => {
                    const { gettext } = django;
                    const imageAlt = slide.productTitle || ''; // Use product title as alt text if available
                    // if (slide.video){
                    //   const contentHtml = `
                    //       <video class="min-w-[200px] max-w-[300px] sm:min-w-[400px] sm:max-w-[500px] sm:max-w-[400px]" src="${slide.video}" autoplay muted loop></video>
                    //   `
                    //   return contentHtml;
                    // }
                    const contentHtml = `
                        <picture class='fancybox-content-description'>
                            <img class="min-w-[200px] sm:min-w-[400px] max-w-[300px] sm:max-w-[500px]" style="flex: 7;" src="${slide.src}" alt="${imageAlt}" />
                            <div class="flex-[1] sm:flex-[3]" id='fancybox-content-description-text' class="w-full items-center">
                                <div class="hidden sm:block h-full w-full">
                                    <div class="flex flex-col h-full">
                                        <div class="w-full h-1/3 p-[0.5rem] flex">
                                            <h2 class="m-auto text-4xl font-bold capitalize">${slide.productTitle}</h2>
                                        </div>
                                        <div class="h-1/3 flex">
                                            <div class="my-auto mx-[1rem]">
                                                <p class="first-letter:uppercase">${slide.productDescription}</p>
                                                <p>${gettext("Dimension")}: ${slide.productDimension}</p>
                                                <p>${gettext("Poids")}: ${slide.productWeight} kg</p>
                                                <p class="text-xl font-semibold mt-[0.5rem] sm:mt-[1.5rem]">${gettext("Prix")}: ${slide.productPrice} &#8364;</p>
                                            </div>
                                        </div>
                                        <div class="h-1/3 flex">
                                            <a href="${slide.urlRedirect}" class="m-auto bg-[#f1f1f1] p-[0.5rem] rounded-xl">${gettext("Détail")}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="block sm:hidden h-full w-full max-w-[300px]">
                                <div class="flex flex-col h-full">
                                    <div class="w-full h-[25%] p-[0.5rem] flex text-center">
                                        <h2 class="m-auto text-xl font-bold capitalize">${slide.productTitle}</h2>
                                    </div>
                                    <div class="h-[75%] flex flex-row">
                                        <div class="my-auto mx-[1rem] flex-[3]">
                                            <p class="first-letter:uppercase">${slide.productDescription}</p>
                                            <p>${gettext("Dimension")}: ${slide.productDimension}</p>
                                            <p>${gettext("Poids")}: ${slide.productWeight} kg</p>
                                            <p class="text-lg font-semibold mt-[0.5rem] sm:mt-[1.5rem]">${gettext("Prix")}: ${slide.productPrice} &#8364;</p>
                                        </div>
                                        <div class="flex flex-[1]">
                                            <a href="${slide.urlRedirect}" class="m-auto bg-[#f1f1f1] p-[0.5rem] rounded-xl">${gettext("Détail")}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </picture>
                    `;
                    return contentHtml;
                },
            },
          });
        Fancybox.bind("[data-fancybox='gallery-detail']", {
        })
	}
    setup();
});

